export type Floor = {
  floor: number | [number, number];
  total?: number | null;
};

export type RangeNumber = {
  min?: number;
  max?: number;
};

export interface FacilityFilterSchema {
  priceFrom?: number | null;
  priceTo?: number | null;
  pricePerSqMFrom?: number | null;
  pricePerSqMTo?: number | null;
  marketPriceFrom?: number | null;
  marketPriceTo?: number | null;
  differenceWithMarketPrice?: number | null;
  mortgageMonthlyPayment?: number | null;
  mortgageInitialPayment?: number | null;
  mortgageTerm?: number | null;
  developerIds?: number[];
  apartmentComplexIds?: number[];
  buildingIds?: number[];
  sellerTypes?: string[];
  isCommissioned?: boolean | null;
  commissioningYears?: number[];
  floorCount?: number[];
  entranceCount?: number[];
  wallMaterials?: string[];
  floors?: number[];
  renovationTypes?: string[];
  facilityTypeIds?: number[];
  bedroomCount?: number[];
  areaFrom?: number | null;
  areaTo?: number | null;
  livingAreaFrom?: number | null;
  livingAreaTo?: number | null;
  kithenAreaFrom?: number | null;
  kithenAreaTo?: number | null;
  ceilingHeightFrom?: number | null;
  ceilingHeightTo?: number | null;
  separateBathroomCount?: number[];
  combinedBathroomCount?: number[];
  balconyCount?: number[];
  loggiaCount?: number[];
  getArchived?: boolean;
  getSold?: boolean;
}

export const ObjectsFiltersForm = {
  fields: [],
};

export interface IObjectsFiltersForm extends FacilityFilterSchema {
  presetId?: number | null;
  presetName?: string;
}

export interface IOption<T> {
  key: T;
  name?: string;
  label: string;
}

export interface DeveloperSummarySchema {
  id: number;
  title: string;
  shortTitle: string;
}

export interface TMedia {
  id: number;
  url: string;
  name: string;
  mimeType: string;
}

export type TApartmentComplexStatus = 'InModeration' | 'Rejected' | 'Available';

export interface ApartmentComplexSummarySchema {
  id: number;
  title: string;
  media: TMedia[];
  status: TApartmentComplexStatus;
  description?: string;
  cadastralNumber: string;
}

export interface SalesPlatformSchema {
  id: number;
  name: string;
  logo?: TMedia;
}

export type TSellerType = 'Developer' | 'Agency' | 'Owner' | 'Reit' | 'Unknown';

export type TWallMaterial =
  | 'Brick'
  | 'Monolith'
  | 'BrickMonolith'
  | 'Panel'
  | 'Block'
  | 'Wood'
  | 'Other';

export type TRenovationType = 'None' | 'Cosmetic' | 'Euro' | 'Designer';

export const squareMetre = 'м²';

export interface TFacilityType {
  id: number;
  fullTitle: string;
  shortTitle: string;
}

export interface FacilityFilterLimitsResponse {
  developers: DeveloperSummarySchema[];
  apartmentComplexes: ApartmentComplexSummarySchema[];
  platforms: SalesPlatformSchema[];
  priceMin: number;
  priceMax: number;
  pricePerSqMMin: number;
  pricePerSqMMax: number;
  marketPriceMin: number;
  marketPriceMax: number;
  floorMin: number;
  floorMax: number;
  floorCountMin: number;
  floorCountMax: number;
  differenceWithMarketPriceMin: number;
  differenceWithMarketPriceMax: number;
  sellerTypes: TSellerType[];
  commissioningYearMin: number;
  commissioningYearMax: number;
  floorCount: number[];
  entranceCount: number[];
  wallMaterials: TWallMaterial[];
  floors: number[];
  renovationTypes: TRenovationType[];
  facilityTypes: TFacilityType[];
  bedroomCount: number[];
  roomCount: number[];
  areaMin: number;
  areaMax: number;
  livingAreaMin: number;
  livingAreaMax: number;
  kitchenAreaMin: number;
  kitchenAreaMax: number;
  ceilingHeightMin: number;
  ceilingHeightMax: number;
  separateBathroomCount: number[];
  combinedBathroomCount: number[];
  balconyCount: number[];
  loggiaCount: number[];
}

export interface FacilityFilterLimitsResponseSecondary {
  pricePerSqMMin: number;
  pricePerSqMMax: number;
  areaMin: number;
  areaMax: number;
  priceMin: number;
  priceMax: number;
  floorMin: number;
  floorMax: number;
  floorCountMin: number;
  floorCountMax: number;
  commissioningYearMin: number;
  commissioningYearMax: number;
  apartmentComplexes: ApartmentComplexSummarySchema[];
  platforms: SalesPlatformSchema[];
  floorCount: number[];
  wallMaterials: TWallMaterial[];
  floors: number[];
  bedroomCount: number[];
  roomCount: number[];
  balconyCount: number[];
  loggiaCount: number[];
  sellerTypes: TSellerType[];
  facilityTypes: TFacilityType[];
}

export interface FilterListProps {
  hidden?: string[];
  limits?: FacilityFilterLimitsResponse | null;
  filters?: Partial<IObjectsFiltersForm>;
  onChange?(name: string, value: any): void;
}

export interface FilterListPropsSecondary {
  hidden?: string[];
  limits?: FacilityFilterLimitsResponseSecondary | null;
  filters?: Partial<IObjectsFiltersForm>;
  onChange?(name: string, value: any): void;
}

export interface NotificationModalProps {
  id?: number;
}

export interface INotificationCreateForm extends IObjectsFiltersForm {
  id: number;
  title: string;
  clientIds: number[];
  showPresets: boolean;
  isSavedForOwner: boolean;
}

export type TSelectValue = number | string | any;

export interface ISelectItem {
  key: TSelectValue;
  label: string | number;
  note?: string;
}

export enum EFavoritesType {
  Personal = 'Personal',
  Shared = 'Shared',
  Customer = 'Customer',
}
